<template lang="pug">
sysLayoutLeftRight2(:layoutConfig='layoutConfig', :rightLoading='rightLoading')
  div(slot='leftSearch')
    selectAjaxNormal(
      v-model='leftQueryParams.businessModule',
      :dataUrl='"/base/enum/businessModule"',
      labelKey='value',
      valueKey='key',
      @selectListLoaded='businessModuleLoaded',
      @input='loadLeftData'
    )

  .formTypeLeftWrap.tinyScrollbarStyle(slot='leftList')
    el-collapse
      el-collapse-item(v-for='(vv1, index1) in leftQueryResult', :key='index1')
        template(slot='title')
          span(style='padding:0 10px 0 10px;') {{ vv1.name }}
        .leftListWrap
          .leftListItem(
            :class='{ active: vv2 === leftEditItem }',
            v-for='(vv2, index2) in vv1.children',
            @click='handleClickOne(vv2)',
            :key='index2'
          ) {{ vv2.name }}

  template(v-if='rightModel')
    DetailConfig1(
      slot='rightMiddle',
      :rightModel='rightModel',
      v-if='isRequest',
      :templateList='templateList',
      :key='leftEditItem.id',
      @ReloadItem='handleClickOne(leftEditItem)'
    )
    DetailConfig2(
      slot='rightMiddle',
      :rightModel='rightModel',
      v-else-if='isFee',
      :key='leftEditItem.id',
      @ReloadItem='handleClickOne(leftEditItem)'
    )
    div(slot='rightMiddle', v-else) 不能配置
</template>

<script>
import apiAxios from '@/apiAxios.js'
import DetailConfig1 from './DetailConfig1.vue'
import DetailConfig2 from './DetailConfig2.vue'

export default {
  components: {
    DetailConfig1,
    DetailConfig2,
  },
  data() {
    return {
      layoutConfig: {
        leftWidth: 250,
        titleLeft: '表单列表',
        titleRight: '表单详情',
        emptyName: '表单',
      },

      leftQueryParams: {
        businessModule: '',
      },
      leftQueryResult: [],
      leftEditItem: null,

      templateList: [],

      rightModel: null,
      rightLoading: false,
    }
  },
  watch: {},
  computed: {
    isRequest() {
      const { businessModule } = this.leftQueryParams
      const { parentCode } = this.leftEditItem
      return (
        businessModule === 'EXPENSE' &&
        ['SQSQ', 'YGBX', 'DGBX'].includes(parentCode)
      )
    },
    isFee() {
      const { businessModule } = this.leftQueryParams
      const { parentCode } = this.leftEditItem
      return (
        businessModule === 'EXPENSE' &&
        ['FYYT', 'FYTX', 'DGYF'].includes(parentCode)
      )
    },
  },
  methods: {
    toLocalModel(rightModel) {
      rightModel.formExpenseTypes = rightModel.formExpenseTypes.map((vv1) => ({
        id: vv1.expenseTypeId,
        name: vv1.expenseTypeName,
      }))
      return rightModel
    },
    async loadTemplateList(requestType) {
      const { data } = await apiAxios.get(
        `/em/formDetail/template/byRequestType/${requestType}`
      )
      this.templateList = data.result
    },
    async handleClickOne(item) {
      this.rightLoading = true
      this.leftEditItem = item
      this.rightModel = null
      if (this.isRequest) {
        await this.loadTemplateList(item.requestType)
      }
      const { data } = await apiAxios.get(`/em/formDetail/byFormId/${item.id}`)
      this.rightModel = this.toLocalModel(data.result)
      this.rightModel.parentCode = item.parentCode
      this.rightModel.formParentName = item.parentName
      this.rightModel.formName = item.name
      this.rightModel.formCode = item.code
      this.rightModel.formId = item.id
      this.rightLoading = false
    },

    filterCanCURD(list) {
      if (this.leftQueryParams.businessModule === 'EXPENSE') {
        return list.filter((vv1) =>
          ['SQSQ', 'YGBX', 'DGBX', 'FYYT', 'FYTX', 'DGYF'].includes(vv1.code)
        )
      } else {
        return list
      }
    },
    async loadLeftData() {
      const { businessModule } = this.leftQueryParams
      this.leftQueryResult = []
      const { data } = await apiAxios.get(
        `/base/form/tree/byBusinessModule/${businessModule}`
      )
      this.leftQueryResult = this.filterCanCURD(data.result)
      this.leftEditItem = null
      this.rightModel = null
    },
    async businessModuleLoaded(list) {
      this.leftQueryParams.businessModule = list[0].key
      await this.loadLeftData()
    },
  },
  async mounted() {},
}
</script>

<style lang="scss" scoped>
@import '~element-ui/packages/theme-chalk/src/common/var';

.formTypeLeftWrap {
  height: 100%;
  overflow: auto;

  ::v-deep .el-collapse-item__header {
    border-bottom: 1px solid #ddd;
    .addBtn {
      display: none;
    }
    &:hover .addBtn {
      display: inline;
    }
  }
  ::v-deep .el-collapse-item__content {
    padding-bottom: 0;
  }
  ::v-deep .el-collapse-item__arrow {
    width: 13px;
    height: 13px;
    line-height: 13px;
  }
}

.leftListItem {
  padding: 10px 10px 10px 20px;
  border-bottom: 1px solid #f3f3f3;
  border-left: 4px solid transparent;
  font-size: $--font-size-base;
  position: relative;

  &:hover,
  &.active {
    color: #f28328;
    background-color: #f2f2f2;
    border-left-color: #f28328;
  }
}
</style>
